import React, { useState, useEffect } from "react";
import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";
import PastRent from "../../components/PastRent";
import "../../assets/css/style.css";
import HomeRent from "../../components/HomeRent";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import { useQueryClient } from "react-query";
import { useNavigate, useLocation } from "react-router-dom";
import { SessionUpdateRequest } from "../../types/types";
import { Config } from "../../Utils/AppConstants";
import { API_CALL_TYPE, UPDATE_SESSION } from "../../services/Api";
import { makeApiCall } from "../../services/ApiService";
import LoaderComponent from "../../components/LoaderComponent";
import { ToastContentProps, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setSessionData, SessionState } from "../../redux/sessionSlice";
import {useBackButton,useAsaSession,useIsLoading,useAsaSessionPagesMutation} from '../../services/AsaSessionServices'
import {  useActiveSubscriptions,useSubscriptionsPlans} from '../../services/AsaApiServices'
import { IAsaSession, SessionPage,Plan } from "../../types/types";
import { showCustomToast } from "../../services/toastService";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";

export default function HomeScreen() {
  const [isMonthly, setIsMonthly] = useState(false);
  const [isLoading, ] = useIsLoading();
  const navigate = useNavigate();
  const {data:session}=useAsaSession()
  const [showHomeRent, setShowHomeRent] = useState(false);

  useEffect(() => {
    AnalyticsService.track("CRB Home Viewed", AnalyticsAction.View, AnalyticsFeature.CRB);
  }, []);
  const [showPastRent, setShowPastRent] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState("Yearly");
  const [pastRentReporting12, setPastRentReporting12] = useState(true);
  const [pastRentReporting24, setPastRentReporting24] = useState(false);
  const [currentRentReporting, setCurrentRentReporting] = useState(true);
  const handleBackClick=useBackButton()
  const [dueAmount, setDueAmount] = useState(0); // Initial monthly due amount
  const [optionselected, setSelectedOption] = useState(12); // Initial monthly due amount
  const location = useLocation();
  const [isChangingData, setisChangingData] = useState(true);
  const sessionMutation= useAsaSessionPagesMutation()
  const [dynamicLink, setDynamicLink] = useState("");
  const passedData = location.state;
  const previousData = location.state;

  


  const headerState = useSelector(
    (state: SessionState) => state?.session.clickedHeader
  );


  const updateSession = async ( ) => {


      const sessionToUpdate:IAsaSession ={...session} as IAsaSession
      sessionToUpdate.sessionPages=undefined
      const sessionpages=[] as SessionPage[]
      sessionpages.push({
        pageNumber: 2, // Assuming this is the second page
        pageName: "HomeScreen",
        pageTitle: "Home Screen",
        pageDescription: "Description of Home Screen",
        pageUrl: "/home",
        pageStatus: "Completed",
        pageStatusMessage: "New Home Screen",
        pageData: JSON.stringify({
          SubscriptionType: subscriptionType,
          PastRentReporting12: pastRentReporting12,
          PastRentReporting24: pastRentReporting24,
          CurrentRentReporting: currentRentReporting,
          OptionSelected: optionselected,
          ClickedHeader: passedData?.clickedHeader,
        }),
     } as SessionPage)
      sessionpages.push({
        pageNumber:81,
        pageName:'Landingyes',
        pageTitle:'Landingyes',
        pageDescription:'Landingyes',
        pageUrl:'/crb',
        pageData: JSON.stringify({Landing: "true" })
      } as SessionPage
      )

      const response= await sessionMutation.mutateAsync({asaSession:sessionToUpdate,extraPages:sessionpages})
    try {

      const response= await sessionMutation.mutateAsync({asaSession:sessionToUpdate,extraPages:sessionpages})
      AnalyticsService.track("CRB Session Update Success", AnalyticsAction.API_Result, AnalyticsFeature.CRB);
      navigate("/payment");
      return response;
    } catch (error) {
      AnalyticsService.track("CRB Session Update Error", AnalyticsAction.API_Result, AnalyticsFeature.CRB);
      showCustomToast(error?.message, true);
      console.error("Error updating session:", error);
     
    }
  };



  const handleToggle = () => {
    
    setIsMonthly((prevIsMonthly) => !prevIsMonthly);
   
    //checkIsMonthly(); // Call checkIsMonthly after toggling isMonthly
  };
 useEffect(() => {
    checkIsMonthly(); // Call checkIsMonthly when isMonthly changes
  }, [isMonthly, showPastRent, showHomeRent, optionselected, headerState]);


  const checkIsMonthly = () => {
    setisChangingData(false);

    const baseAmount = isMonthly ? 6.95 : 49; // Base amount for current rent reporting
    const pastRentAmount12 = isMonthly ? 49 : 49; // Amount for 12-month past rent reporting
    const pastRentAmount24 = isMonthly ? 65 : 65; // Amount for 24-month past rent reporting
    
    let totalAmount = 0;

    setSubscriptionType(isMonthly ? "Monthly" : "Yearly");
    if (showPastRent) {
      totalAmount += optionselected === 12 ? pastRentAmount12 : pastRentAmount24;
    }
    if (showHomeRent) {
      totalAmount += baseAmount;
    }
    setDueAmount(totalAmount);
  };
  useEffect(() => {
    const targetPage = session?.sessionPages?.find(page => page.pageName === 'ASAVaultDynamicLink')
    if(targetPage){
      const pageData = JSON.parse(targetPage.pageData);
      const dynamicLink = pageData.dynamicLink;
      setDynamicLink(dynamicLink);
    }

  }, [session]);

  useEffect(() => {
    const targetPage = session?.sessionPages?.find(page => page.pageName === 'fromPayment')
 
    if (targetPage && previousData === "fromPayment" && isChangingData) {
 
      const sessionPages = session?.sessionPages;
      const homeScreenPageData= sessionPages?.find((page) => page.pageName === "HomeScreen")
      if (homeScreenPageData) {
        const pageData = JSON.parse(homeScreenPageData.pageData); // Assuming the second page, index 1
        const subscriptionTypeValue = pageData.SubscriptionType;
        const PastRentReporting12 = pageData.PastRentReporting12;
        const PastRentReporting24 = pageData.PastRentReporting24;
        const CurrentRentReporting = pageData.CurrentRentReporting;

        let amount; // Declare amount variable

        let totalAmount = 0; // Initialize totalAmount variable to zero

        if (
          subscriptionTypeValue &&
          subscriptionTypeValue.toLowerCase() == "monthly"
        ) {
          setIsMonthly(true);
          setPastRentReporting12(false);
          setPastRentReporting24(false);

          if (PastRentReporting12) {
            setPastRentReporting12(true);
            setSelectedOption(12);
            setShowPastRent(true);
          }
          if (PastRentReporting24) {
            setPastRentReporting24(true);
            setSelectedOption(24);
            setShowPastRent(true);

          }
          setCurrentRentReporting(false);
          if (CurrentRentReporting) {
            setCurrentRentReporting(true);
            setShowHomeRent(true);
          }

          setSubscriptionType("Monthly");
        } else {
          setCurrentRentReporting(false);
          setPastRentReporting12(false);
          setPastRentReporting24(false);

          if (PastRentReporting12) {
            setSelectedOption(12);
            setPastRentReporting12(true);
            setShowPastRent(true);
          }
          if (PastRentReporting24) {
            setPastRentReporting24(true);

            setSelectedOption(24);
            setShowPastRent(true);
          }
          if (CurrentRentReporting) {
            amount = 49;
            setCurrentRentReporting(true);
            setShowHomeRent(true);
          }

          setSubscriptionType("Yearly");
        }

        // Now you have currentRentValue and pastRentValue calculated based on the retrieved data
      } else {
        console.error("Session data doesn't have enough pages.");
      }
    } else {
      //console.error("updatedsessionData is undefined or null.");
    }
  }, [session, optionselected, isChangingData]);



  const handleContinueClick = async () => {
    AnalyticsService.track("CRB Continue Clicked", AnalyticsAction.Click, AnalyticsFeature.CRB, {
      dueAmount: dueAmount,
      subscriptionType: subscriptionType,
    });
    await updateSession();
  }

  useEffect(() => {
    setShowPastRent(false);
    setShowHomeRent(true);
    setPastRentReporting12(false);
    setPastRentReporting24(false);
    setSubscriptionType("Yearly");
    const clickedHeader=passedData?.clickedHeader?? headerState

      if (clickedHeader === "Past Rent Reporting") {
        // Calculate due amount based on some other logic
        //setDueAmount(/* calculated value */);
        setShowPastRent(true);
        setPastRentReporting12(true);
        setShowHomeRent(false);
        setCurrentRentReporting(false);
        if (isMonthly) {
          setSubscriptionType("Monthly");
          updateDueAmount(49);
        } else {
          setSubscriptionType("Yearly");
        
        }
        //  setDueAmount(49)
      } else if (clickedHeader === "Past & Ongoing Rent Reporting") {
        // Calculate due amount based on some other logic
        setShowPastRent(true);
        setShowHomeRent(true);
        setPastRentReporting12(true);
        if (isMonthly) {
          setSubscriptionType("Monthly");
        } else {
          setSubscriptionType("Yearly");
        }
      }
    
  }, [passedData,headerState]);
  // Define callback function to update dueAmount

  const updateDueAmount = (amount: number) => {
    setDueAmount(amount); // Directly set the due amount to the new amount
  };

  const handleHomeRentClick = () => {
    // setShowHomeRent(true);
  };

  const handleCloseClick = () => {

    setShowHomeRent(false);
    setCurrentRentReporting(false);

  };

  const handleHomeRentAdd = () => {
    setShowHomeRent(true);
    setCurrentRentReporting(true);

  };

  const handlePastRentAdd = () => {
    setPastRentReporting12(true);
    setPastRentReporting24(false);
    setShowPastRent(true);

  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handlePastRentClose = (amount: any) => {
    // setonAddHome(false);
    // Logic to close the PastRent component

    setPastRentReporting12(false);
    setPastRentReporting24(false);

    setShowPastRent(false);
  };

  const handleOptionSelect = (option: number) => {
    setisChangingData(false);
    setSelectedOption(option);
    if (isMonthly) {
      if (showHomeRent && showPastRent) {
        if (option == 12) {
          setPastRentReporting12(true);
          setPastRentReporting24(false);
          setDueAmount(55.95);
        } else {
          setPastRentReporting12(false);
          setPastRentReporting24(true);
       
        }
      } else {
        if (showHomeRent) {
          if (option == 12) {
            setPastRentReporting12(true);
            setPastRentReporting24(false);
            setDueAmount(55.95);
          } else {
            setPastRentReporting12(false);
            setPastRentReporting24(true);
          }
        } else {
          if (option == 12) {
            setPastRentReporting12(true);
            setPastRentReporting24(false);
            //setDueAmount(98);
          } else {
            setPastRentReporting12(false);
            setPastRentReporting24(true);
            // setDueAmount(114);
          }
        }
      }
    } else {
      if (showHomeRent && showPastRent) {
        if (option == 12) {
          setPastRentReporting12(true);
          setPastRentReporting24(false);
        } else {
          setPastRentReporting12(false);
          setPastRentReporting24(true);
        }
      } else {
        if (showHomeRent) {
          if (option == 12) {
            setPastRentReporting12(true);
            setPastRentReporting24(false);
          } else {
            setPastRentReporting12(false);
            setPastRentReporting24(true);
          }
        } else {
          if (option == 12) {
            setPastRentReporting12(true);
            setPastRentReporting24(false);
          } else {
            setPastRentReporting12(false);
            setPastRentReporting24(true);
          }
        }
      }
    }
    setSelectedOption(option);
    setShowPastRent(true); // Show PastRent component
  };

  function handleClick() {
    // Check if dynamicLink is defined and not empty
    if (dynamicLink && dynamicLink.trim() !== "") {
      // Redirect to dynamicLink
      window.location.href = dynamicLink;

      setTimeout(() => {
        if (dynamicLink && dynamicLink.trim() !== "") {
          // Redirect to dynamicLink

          navigate("/error", { state: passedData });
        } else {
          // Handle the case when dynamicLink is not valid
          console.error("Dynamic link is not valid or empty.");
          // You can choose to do nothing or provide a fallback behavior here
        }
      }, 2000); // Adjust the delay as needed
    } else {
      handleBackClick();
      console.error("Dynamic link is not valid or empty.");
      // You can choose to do nothing or provide a fallback behavior here
    }
  }

  return (
    <div className="relative bg-theme flex flex-col justify-between overflow-y-scroll py-10 text-gray-100 pm sta mx-auto border space-y-5 h-screen">
      {isLoading && <LoaderComponent />}{" "}
      {/* Render loader based on showLoader state */}
      {/* Render loader based on showLoader state */}
      <div className="flex items-center justify-between">
        <div onClick={handleClick} className="flex items-center p-4 space-x-4">
          <img
            className="w-6 h-6 sm:w-8 sm:h-8"
            src={arrow_back_ios_new}
            alt="Back"
          />
          <p className="text-sm sm:text-base font-medium asareturn  poppins-semibold text-white">
            return to ASA Vault
          </p>
        </div>
      </div>
      <div className="mx-auto space-y-2">
        <div className="flex flex-col space-y-3 items-center justify-center">
          <p
            className="text-lg summarytxt sm:text-2xl text-gray-100 poppins-semibold cursor-pointer leading-6 mt-3"
            onClick={handleHomeRentClick}
          >
            Your service summary.
          </p>

          <div className="flex flex-col items-center">
            <strong className="custom-font  poppins-semibold mt-5">
              ${dueAmount.toFixed(2)}
            </strong>
            <p className="due-font poppins-regular mt-2">
              due {isMonthly ? "today" : "today"}
            </p>
          </div>

          <div className="flex items-center font-semibold text-gray-300 text-sm space-x-2">
            <div className="bg-white/30 backdrop-blur-lg rounded-3xl overflow-hidden py-1">
              <span
                className={`px-4 py-2 month-toggle poppins-bold text-white cursor-pointer text-xs sm:text-base transition-all duration-500 rounded-full ${
                  isMonthly
                    ? "bg-white/30 text-gray-50"
                    : "bg-transparent text-gray-300"
                }`}
                onClick={handleToggle}
              >
                Monthly
              </span>
              <span
                className={`px-4 py-2  month-toggle cursor-pointer text-xs sm:text-base transition-all duration-500 rounded-full ${
                  !isMonthly
                    ? "bg-white/30 text-gray-50"
                    : "bg-transparent text-gray-300"
                }`}
                onClick={handleToggle}
              >
                Annually
              </span>
            </div>
          </div>

          {isMonthly && (showHomeRent || showPastRent) && showHomeRent && (
            <div className="flex flex-col items-center">
              <strong className="month-span-val poppins-semibold mt-5">
                $6.95
              </strong>
              <p className="month-span poppins-extralight mt-3">due monthly</p>
              <p className="month-span poppins-extralight mt-2">
                starting next month
              </p>
            </div>
          )}
        </div>
      </div>
      {showHomeRent ? (
        <HomeRent isMonthly={isMonthly} onCloseClick={handleCloseClick} />
      ) : (
        <div>
          <p
            onClick={handleHomeRentAdd}
            className="flex items-center justify-center text-sm text-gray-300 cursor-pointer font-poppins"
          >
            <AddCircleOutlineRoundedIcon className="circleaddicon" />
            <span className="poppins-medium ml-2">
              Add current rent reporting
            </span>
          </p>
          <p className=" month-toggle text-sm poppins-medium text-white ml-1 flex items-center justify-center cursor-pointer mt-1">
            Ongoing boost
          </p>
        </div>
      )}
      {showPastRent ? (
        <PastRent
          onCloseClick={() => setShowPastRent(false)}
          onAddToDue={updateDueAmount}
          onSelectOption={handleOptionSelect}
          onPastRentClose={handlePastRentClose}
          selectedOptionProp={optionselected} // Pass the selected option as a prop
        />
      ) : (
        <div>
          <p
            onClick={handlePastRentAdd}
            className="flex items-center justify-center text-sm text-gray-300 cursor-pointer"
          >
            <AddCircleOutlineRoundedIcon className="circleaddicon" />
            <span className="poppins-text">Add past rent reporting</span>
          </p>
          <p className=" month-toggle poppins-medium ml-2  text-white ml-1 flex items-center justify-center text-sm text-gray-300 cursor-pointer mt-1">
            Immediate Boost
          </p>
        </div>
      )}
      {!showHomeRent && !showPastRent && (
        <div>
          <p
            onClick={handleHomeRentAdd}
            className="flex items-center only-font justify-center text-gray-300 cursor-pointer"
            // Increase icon size
          >
            <ArrowUpwardRoundedIcon />
          </p>
          <p className="  creporting poppins-text ml-2 text-lg poppins-semibold text-white ml-1 flex items-center justify-center cursor-pointer mt-1 poppins-700">
            Select a reporting option
          </p>
        </div>
      )}
      <p className="mx-auto text-center text-white leading-6 mt-5">
        <span className="block inf poppins-text mt-8 text-center">
          The information provided will be
        </span>
        <span className="block inf poppins-text text-center">
          shared with Credit Rent Boost to help
        </span>
        <span className="block inf poppins-text text-center">
          improve your credit score.
        </span>
      </p>
      {showHomeRent || showPastRent ? (
        <button
          onClick={handleContinueClick}
          className="poppins-bold  continue sm:w-[60%] md:w-[35%] lg:w-[20%] w-[80%] p-4 mx-auto bg-white text-theme h-[58] text-center"
        >
          Continue
        </button>
      ) : (
        <div className="poppins-bold continue-disable sm:w-[60%] md:w-[35%] lg:w-[20%] w-[80%] p-4 mx-auto bg-white text-theme h-[58] text-center">
          Continue
        </div>
      )}
    </div>
  );
}
